import React from "react";
import infoConstants from "../../../shared/infoConstants";

export const SupportText = ({ className = "", className2 = "" }) => {
  return (
    <div className={className}>
      <span className={`${className2} text-align-center mb-1 `}>
        For support, contact Pharmacare Group at
        <a href={`tel:${infoConstants.nhsPhoneNumber}`}>
          <b> {infoConstants.nhsPhoneNumber}</b>
        </a>
        , or email
        <a href={`mailto: ${infoConstants.nhsEmail}`}>
          <b> {infoConstants.nhsEmail}</b>
        </a>
      </span>
    </div>
  );
};
